import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

const randomColors = ['#B4E4DC', '#ECF8EF'];

interface Props {
	index?: number;
}

export const BoxWrapper = styled.div<Props>`
	margin: 24px 24px 0px 0px;
	height: 100%;
	width: 100%;
	padding: 50px 24px;
	box-sizing: border-box;
	background: ${(props) => randomColors[props.index ? props.index % 2 : 0]};
	color: #37494b;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 28px; /* 175% */
	letter-spacing: -0.6px;
	&:last-child {
		width: 100%;
	}

	@media ${device.tablet} {
		width: 100%;
	}

	@media ${device.mobile} {
		width: 100%;
	}
`;
export const EvaluationCriteriaWrapper = styled.div`
	min-height: 300px;
	max-height: fit-content;
	box-sizing: border-box;
	width: 100%;
	.content {
		height: 100%;
		padding: 50px 0px;
		display: flex;
		flex-direction: column;
		.title {
			color: ${colors.black};
			font-size: 3.25rem;
			font-family: 'Segnifier-Regular';
			margin-bottom: 48px;
		}
		.boxes {
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			align-items: center;
		}
	}
	@media ${device.tablet} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.title {
				margin: 0;
				margin-bottom: 30px;
			}
			.boxes {
				flex-direction: column;
			}
		}
	}

	@media ${device.mobile} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.title {
				margin: 0;
				margin-bottom: 30px;
			}
			.boxes {
				flex-direction: column;
			}
		}
	}
`;
